import { render, staticRenderFns } from "./TemplatePageActionDelete.vue?vue&type=template&id=c7024394&"
import script from "./TemplatePageActionDelete.vue?vue&type=script&lang=ts&"
export * from "./TemplatePageActionDelete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports